<template>
  <!-- eslint-disable vue/no-mutating-props -->
  <v-dialog
    v-model="showModalAddPhoto"
    persistent
    max-width="600px"
  >
    <!-- eslint-enable vue/no-mutating-props -->
    <v-card>
      <v-progress-linear
        v-if="isUploading"
        absolute
        color="primary accent-4"
        indeterminate
        rounded
        height="5"
      />
      <v-card-title>
        <span class="headline">{{ $t("profile.addPhoto.changePic") }}</span>
      </v-card-title>
      <v-tabs>
        <v-tabs-slider color="blue" />
        <v-tab>
          {{ $t("profile.addPhoto.selectImage") }}
        </v-tab>
        <v-tab>
          {{ $t("profile.addPhoto.chooseAvatar") }}
        </v-tab>
        <v-tab-item>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  class="text-center"
                >
                  <img
                    v-if="$store.state.user.user.customPhotoURL"
                    :src="$store.state.user.user.customPhotoURL"
                  >
                  <img
                    v-else-if="$store.state.user.user.photoURL"
                    :src="$store.state.user.user.photoURL"
                  >
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  class="text-center"
                >
                  <v-btn
                    id="pick-avatar"
                    color="primary"
                  >
                    {{
                      $t("profile.addPhoto.uploadPhoto")
                    }}
                  </v-btn>
                  <div class="text-center">
                    <avatar-cropper
                      :upload-handler="uploadPhoto"
                      :cropper-options="cropperOptionTag()"
                      :labels="labelTag()"
                      trigger="#pick-avatar"
                    />
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-tab-item>
        <v-tab-item>
          <v-row>
            <v-col cols="3" />
            <v-col
              cols="6"
              class="text-center"
            >
              <random-avatar
                v-if="showRandomAvatar"
                id="avatarSvg"
              />
              <v-btn
                color="primary"
                class="mr-2"
                @click="randomizeAvatar"
              >
                {{ $t("profile.addPhoto.random") }}
              </v-btn>
              <v-btn
                color="primary"
                @click="selectAvatar"
              >
                {{
                  $t("profile.addPhoto.select")
                }}
              </v-btn>
            </v-col>
            <v-col cols="3" />
          </v-row>
        </v-tab-item>
      </v-tabs>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          @click="closeModal"
        >
          {{ $t("profile.changePassword.close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import RandomAvatar from './randomAvatar.vue'
  import AvatarCropper from 'vue-avatar-cropper'
  import { svgAsPngUri } from 'save-svg-as-png'
  import { uploadFile } from '@/firebase'
  export default {
    name: 'AddPhotoModal',
    components: { RandomAvatar, AvatarCropper },
    props: ['showModalAddPhoto', 'closeModal'],
    data () {
      return {
        isUploading: false,
        showRandomAvatar: true,
      }
    },
    methods: {
      labelTag () {
        return {
          submit: this.$t('profile.addPhoto.select'),
          cancel: this.$t('profile.addPhoto.cancel'),
        }
      },
      cropperOptionTag () {
        return {
          aspectRatio: 1,
          autoCropArea: 1,
          viewMode: 1,
          movable: true,
          zoomable: true,
        }
      },
      async uploadPhoto (cropper) {
        this.isUploading = true
        const filename = 'profile_pic/' + this.$store.state.user.user.uid + '.png'
        cropper.getCroppedCanvas({ width: 256, height: 256 }).toBlob(blob => {
          uploadFile(blob, filename)
            .then(url => {
              this.$store.dispatch('SAVE_USER_INFO', {
                user: this.$store.state.user,
                userInfo: {
                  customPhotoURL: url,
                },
              })
              this.isUploading = false
            })
            .catch(error => {
              console.log('error uploading file: ' + error)
              this.isUploading = false
            })
        }, 'image/png')
      },
      randomizeAvatar () {
        this.showRandomAvatar = false
        this.$nextTick(() => {
          this.showRandomAvatar = true
        })
      },
      async selectAvatar () {
        this.isUploading = true
        const filename = 'profile_pic/' + this.$store.state.user.user.uid + '.png'
        svgAsPngUri(document.getElementById('avatarSvg'), {
          width: 256,
          height: 256,
        })
          .then(uri => {
            return fetch(uri)
          })
          .then(res => {
            return res.blob()
          })
          .then(blob => {
            return uploadFile(blob, filename)
          })
          .then(url => {
            this.$store.dispatch('SAVE_USER_INFO', {
              user: this.$store.state.user,
              userInfo: {
                customPhotoURL: url,
              },
            })
            this.isUploading = false
          })
          .catch(error => {
            console.log('error uploading file: ' + error)
            this.isUploading = false
          })
      },
    },
  }
</script>
